import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { KeycloakProvider } from '@react-keycloak/web'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthenticatedUserProvider } from './AuthenticatedUserContext'
import { LanguageConsumer, LanguageProvider } from './LanguageContext'
import * as serviceWorker from './serviceWorker'
import ThemeProvider from './ThemeProvider'
import keycloak from './Services/keycloak'
import Layout from './components/Layout'
import { LayoutProvider } from './context/LayoutContext'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Close as CloseIcon } from '@material-ui/icons'

const CloseButton = ({ closeToast, className }) => (
  <CloseIcon className={className} onClick={closeToast}/>
)

ReactDOM.render(
  <KeycloakProvider
    keycloak={keycloak}
    onEvent={(event, error) => {
      // console.log('onKeycloakEvent', event, error)
    }}
    onTokens={(tokens) => {
      // console.log('onKeycloakTokens', tokens)
    }}
  >
    <Router forceRefresh={false}>
      <LanguageProvider>
        <LanguageConsumer>
          {({ locale }) => (
            <AuthenticatedUserProvider locale={locale}>
              <LayoutProvider>
                <ThemeProvider>
                  <ToastContainer
                    className={'toasts-container'}
                    closeButton={
                      <CloseButton className={'notification-close-button'}/>
                    }
                    limit={5}
                    closeOnClick={false}
                    progressClassName={'notification-progress'}
                  />
                  <Layout/>
                </ThemeProvider>
              </LayoutProvider>
            </AuthenticatedUserProvider>
          )}
        </LanguageConsumer>
      </LanguageProvider>
    </Router>
  </KeycloakProvider>,
  document.getElementById('root')
)

serviceWorker.unregister()
